import { defineAsyncComponent } from 'vue'
export default {
  profile: defineAsyncComponent(() => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/layouts/profile.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Common/layouts/default.vue").then(m => m.default || m))
}